import Urls from "../Urls";
import LocalToken from "../Method/LocalToken";
import { axiosInstance } from "./AxiosInstance";
class ProfileReq {
  Profile = () => {
    return axiosInstance({
      url: Urls.teacherProfile(),
      method: "get",
    });
  };
  UpdateAvatar = (data) => {
    return axiosInstance({
      method: "PATCH",
      url: Urls.UploadAvatar(),
      data,
    });
  };
  UpdateUser = (data) => {
    return axiosInstance({
      url: Urls.updateInfo(),
      method: "PATCH",
      data,
    });
  };
  UpdateSheba = (data) => {
    return axiosInstance({
      url: Urls.updateSheba(),
      method: "PATCH",
      data,
    });
  };
  UpdateTeacher = (data) => {
    return axiosInstance({
      method: "PUT",
      url: Urls.teacherProfile(),
      data,
    });
  };
  UpdateTeacherResume = (data) => {
    return axiosInstance({
      method: "PUT",
      url: Urls.teacherUpdateResume(),
      data,
    });
  };
  CreateTeacherResume = (data) => {
    return axiosInstance({
      method: "POST",
      url: Urls.teacherCreateResume(),
      data,
    });
  };
  UpdateTeacherVideo = ({ data, onUploadProgress }) => {
    return axiosInstance({
      method: "PATCH",
      url: Urls.teacherUploadIntro(),
      data,
      onUploadProgress,
    });
  };
  Resume = () => {
    return axiosInstance({
      url: Urls.teacherResume(),
      method: "get",
    });
  };
  ListTeacherAvai = (params) => {
    return axiosInstance({
      url: Urls.ListTeacherAvai(),
      method: "get",
      params,
      headers: {
        Authorization: `Bearer ${LocalToken.Get("tokenObj").accToken}`,
      },
    });
  };
  TeacherAvaiUpdate = (data) => {
    return axiosInstance({
      url: Urls.ListTeacherAvai(),
      method: "PUT",
      data,
      headers: {
        Authorization: `Bearer ${LocalToken.Get("tokenObj").accToken}`,
      },
    });
  };
  Weekly = (id) => {
    return axiosInstance({
      url: Urls.teacherWeekly(id),
      method: "GET",
    });
  };
  WeeklyUpdate = (data) => {
    return axiosInstance({
      url: Urls.WeeklyUpdate(),
      method: "PUT",
      data,
    });
  };
  UpdatePassword = (data) => {
    return axiosInstance({
      url: Urls.updatePassword(),
      method: "PATCH",
      data,
    });
  };
  LessonPackage = () => {
    return axiosInstance({
      url: Urls.teacherLessonPackage(),
      method: "GET",
    });
  };
  PackageUpdate = (id, data) => {
    return axiosInstance({
      url: Urls.teacherPackageID(id),
      method: "PUT",
      data,
    });
  };
}
export default new ProfileReq();
